<template>
  <div id="viewImage">
    <div @click="close" id="bg_div"></div>
    <transition enter-active-class="animated zoomIn">
      <img id="viewImageImg"
           v-hammer:panstart="onPanStart"
           v-hammer:panmove="onPanMove"
           v-hammer:panend="onPanEnd"
           v-hammer:pan="onTap"
           v-hammer:pinch="onTap"
           @click="close"
           v-hammer:pinchstart="onPinchStart"
           v-hammer:pinchmove="onPinchMove"
           v-if="imageSrc!=''"
           :style="imgStyle"
           :src="imageSrc"/>
<!--      <img id="viewImageImg"-->
<!--           @click="close"-->
<!--           v-if="imageSrc!=''"-->
<!--           :style="imgStyle"-->
<!--           :src="imageSrc"/>-->
    </transition>
  </div>
</template>

<script>
import store from '../store'
export default {
  name: "viewImage",
  data(){
    return {
      pan:{
        x:0,
        y:0,
      },
      imgInfo:{
        left:0,
        top:0,
        center:{
          x:0,
          y:0
        },
        scale:1,
        width:0,
        height:0
      },
      imgStyleData:{
        left:0,
        top:0,
        scale:1,
        width:0,
        height:0
      },
      imageSrc:''
    }
  },
  mounted() {
    let img=new Image();
    img.onload=function (){
      let top=img.height;
      top*=store.state.WindowSize.WindowWidth/img.width;
      top=store.state.WindowSize.WindowHeight-top;
      if (top<0) top=0;
      this.imgStyleData.left=0;
      this.imgStyleData.top=top/2;
      this.imgStyleData.scale=1;
      this.imgStyleData.width=store.state.WindowSize.WindowWidth;
      this.imgStyleData.height=img.height*store.state.WindowSize.WindowWidth/img.width;
      this.imageSrc=store.state.viewImageSrc;
    }.bind(this)
    img.src=store.state.viewImageSrc;
  },
  methods:{
    onTap () {
      // console.log(124312341234)
    },
    close () {
      store.commit('setImageSrc','')
    },
    // onPanStart (e) {
    //   this.pan.x=e.center.x;
    //   this.pan.y=e.center.y;
    //   this.imgInfo.left=this.imgStyleData.left;
    //   this.imgInfo.top=this.imgStyleData.top;
    // },
    // onPanMove (e) {
    //   let left=e.center.x-this.pan.x
    //   let top=e.center.y-this.pan.y
    //   left+=this.imgInfo.left
    //   top+=this.imgInfo.top
    //   this.imgStyleData.left=left
    //   this.imgStyleData.top=top
    // },
    onPanStart (e) {
      this.pan.x=e.center.x;
      this.pan.y=e.center.y;
      this.imgInfo.left=this.imgStyleData.left;
      this.imgInfo.top=this.imgStyleData.top;
    },
    onPanEnd(e){

    },
    onPanMove (e) {
      let left=e.center.x-this.pan.x
      let top=e.center.y-this.pan.y
      left+=this.imgInfo.left
      top+=this.imgInfo.top

      if(left>0) {
        left=0;
      }
      if((left+this.imgStyleData.width)<store.state.WindowSize.WindowWidth)
        left=store.state.WindowSize.WindowWidth-this.imgStyleData.width;

      let maxTop=0;
      let minTop=0;
      if(this.imgStyleData.height>store.state.WindowSize.WindowHeight){
        maxTop=0;
        minTop=store.state.WindowSize.WindowHeight-this.imgStyleData.height;
      }else{
        maxTop=minTop=(store.state.WindowSize.WindowHeight-this.imgStyleData.height)/2
      }
      if(top>maxTop) top=maxTop;
      if(top<minTop) top=minTop;

      this.imgStyleData.left=left
      this.imgStyleData.top=top
    },
    // onPinchStart (e) {
    //   this.imgInfo.scale=this.imgStyleData.scale;
    // },
    // onPinchMove (e) {
    //   this.imgStyleData.scale=e.scale*this.imgInfo.scale>=1?e.scale*this.imgInfo.scale:1;
    // },
    onPinchStart (e) {
      this.imgInfo.scale=this.imgStyleData.scale;
      this.imgInfo.left=this.imgStyleData.left;
      this.imgInfo.top=this.imgStyleData.top;
      this.imgInfo.width=this.imgStyleData.width;
      this.imgInfo.height=this.imgStyleData.height;
      this.imgInfo.center.x=e.center.x;
      this.imgInfo.center.y=e.center.y;
    },
    onPinchMove (e) {
      this.imgStyleData.scale=e.scale*this.imgInfo.scale;
      if(this.imgStyleData.scale<1) this.imgStyleData.scale=1;

      // this.imgStyleData.width=this.imgInfo.width*this.imgStyleData.scale;
      // this.imgStyleData.height=this.imgInfo.height*this.imgStyleData.scale;

      this.imgStyleData.width=store.state.WindowSize.WindowWidth*this.imgStyleData.scale;
      this.imgStyleData.height=this.imgInfo.height/this.imgInfo.width*this.imgStyleData.width;

      let left=this.imgInfo.width-this.imgStyleData.width;
      left*=(this.imgInfo.center.x-this.imgInfo.left)/this.imgInfo.width
      // left*=(e.center.x-this.imgInfo.left)/this.imgInfo.width
      left+=this.imgInfo.left;
      // left+=e.center.x-this.imgInfo.center.x;

      let top=this.imgInfo.height-this.imgStyleData.height;
      top*=(this.imgInfo.center.y-this.imgInfo.top)/this.imgInfo.height;
      // top*=(e.center.y-this.imgInfo.top)/this.imgInfo.height;
      top+=this.imgInfo.top;
      // top+=e.center.y-this.imgInfo.center.y;

      if(left>0) left=0;
      if((left+this.imgStyleData.width)<store.state.WindowSize.WindowWidth)
        left=store.state.WindowSize.WindowWidth-this.imgStyleData.width;

      let maxTop=0;
      let minTop=0;
      if(this.imgStyleData.height>store.state.WindowSize.WindowHeight){
        maxTop=0;
        minTop=store.state.WindowSize.WindowHeight-this.imgStyleData.height;
      }else{
        maxTop=minTop=(store.state.WindowSize.WindowHeight-this.imgStyleData.height)/2
      }
      if(top>maxTop) top=maxTop;
      if(top<minTop) top=minTop;

      this.imgStyleData.left=left;
      this.imgStyleData.top=top;
    }
  },
  computed:{
    imgStyle(){
      return {
        left:this.imgStyleData.left+'px',
        top:this.imgStyleData.top+'px',
        width:this.imgStyleData.width+'px',
        height:this.imgStyleData.height+"px"
        // transform:"scale("+this.imgStyleData.scale+")"
      }
    }
  }
}
</script>

<style lang="less" scoped>
#viewImage{
  width: 100vw;
  height: 100vh;
  position:fixed;
  left:0px;top:0px;
  z-index: 31;

  #bg_div{
    background: rgba(0,0,0,1);
    position: absolute;
    left:0px;top:0px;
    width: 100vw;
    height: 100vh;
  }
  img{
    animation-duration: .3s;
    -webkit-animation-duration: .3s;
    width: 100%;
    position: absolute;
    left: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/viewImage.vue